import { groq } from '@nuxtjs/sanity';

const getVideoDatasFromRef = (ref) => groq`*[_id=="${ref}"]{
  ...
}`;

export default getVideoDatasFromRef;
